module.exports = __webpack_public_path__ + "static/trialjectory-b34c900113401df572574715531e3198.png";